import styled from '@emotion/styled'

import { ButtonLink } from '@/components/Button'
import { Card } from '@/components/Card'
import { Icon } from '@/components/Icon'
import { Image } from '@/components/Image'
import { BodyM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

import type { PremiumArticleCard } from '../types'

interface Props {
  card: PremiumArticleCard
  className?: string
}

const CardStyles = styled(Card)`
  height: 16.25rem;
  width: 16.5rem;
  .img {
    width: 100%;
    height: 9.3125rem;
    position: relative;
  }

  .content__title {
    padding: 1rem 1rem 0.5rem 1rem;
  }

  .content__cta {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0.5rem;
    margin: 0 0.5rem;
  }
  ${CONFIG.media.lg} {
    width: 19.3215rem;
  }
`
const CardArticlePremium = ({ card, className }: Props) => (
  <CardStyles className={className}>
    <div className="img">
      <Image layout="fill" source={card.image?.url} alt={card.image?.alt} />
    </div>
    <div className="content">
      <BodyM className=" content__title" color="dark-high">
        {card.content}
      </BodyM>
      {card.cta && (
        <ButtonLink className="content__cta" modifier="ghost" href={card.cta.link}>
          {card.cta.label}
          <Icon color="primary" width="30" height="30" href="external" icon={'external'} />
        </ButtonLink>
      )}
    </div>
  </CardStyles>
)

export default CardArticlePremium
